import { render, staticRenderFns } from "./DataStatistics.vue?vue&type=template&id=1bb878c3&scoped=true&"
import script from "./DataStatistics.vue?vue&type=script&lang=ts&"
export * from "./DataStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./DataStatistics.vue?vue&type=style&index=0&id=1bb878c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb878c3",
  null
  
)

component.options.__file = "DataStatistics.vue"
export default component.exports